import { isConditionalContent, serializeConditionalContent } from './conditionalContent';
import { DynamicContent } from '../domain';

export const serializeDynamicContent = (content: DynamicContent | null) => {
  if (isConditionalContent(content)) return serializeConditionalContent(content);
  // TODO: add for each serializer here
  throw new Error('cannot serialize dynamic content');
};
